<template>
  <v-progress-circular
    :size="size"
    :width="width"
    color="third"
    indeterminate
  />
</template>

<script>

export default {
  props: {
    size: {
      type: Number,
      default: 70
    },
    width: {
      type: Number,
      default: 7
    }
  }
};

</script>
